import { render } from "./TherapyRoomSection.vue?vue&type=template&id=262fd17f&scoped=true"
import script from "./TherapyRoomSection.vue?vue&type=script&lang=js"
export * from "./TherapyRoomSection.vue?vue&type=script&lang=js"

import "./TherapyRoomSection.vue?vue&type=style&index=0&id=262fd17f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262fd17f"]])

export default __exports__